import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { Auth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private afAuth: Auth,
  ) { }

  async canActivate(): Promise<boolean> {
    const isAdminPage = environment.isAdminPage;

    if (!isAdminPage) {
      return true;
    } else {
      const user = await new Promise((resolve) => {
        this.afAuth.onAuthStateChanged(resolve);
      });
      if (user) {
        return true;
      } else {
        this.router.navigate(['/login']);
        return false;
      }
    }
  }
}